import React from 'react';

interface HighWorkSurfaceProps {}

export function HighWorkSurface(props: Readonly<HighWorkSurfaceProps>) {
	return (
		<svg width={102} height={72} viewBox="0 0 102 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_16454)">
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M38.895 21.79h22.504c2.309 0 3.94 1.162 4.198 5.097l2.863 43.642c.258 3.936-1.892 5.1-4.198 5.1h-28.23c-2.306 0-4.456-1.157-4.198-5.1l2.863-43.642c.259-3.943 1.889-5.098 4.197-5.098z"
				/>
				<mask x={30} y={21} width={39} height={55} maskUnits="userSpaceOnUse" style={{ maskType: 'luminance' }}>
					<path d="M30.508 21.79H68.83v53.9H30.508v-53.9z" fill="#fff" />
				</mask>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M35.866 83.576v-3.282h-8.992v-9.927h-3.62V81.95c0 .894.807 1.626 1.793 1.626h10.82z"
				/>
				<path
					fill="#505A63"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22.462 57.777h5.586c.726 0 1.273.709 1.319 1.567l.61 11.26c0 .852-.595 1.567-1.319 1.567H21.94c-.722 0-1.357-.706-1.317-1.567l.523-11.26c.038-.86.591-1.567 1.316-1.567z"
				/>
				<path
					fill="#71828F"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M64.156 83.576v-3.282h8.993v-9.927h3.62V81.95c0 .894-.807 1.626-1.794 1.626H64.156z"
				/>
				<mask
					id="a"
					x={70}
					y={57}
					width={10}
					height={16}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M70.094 57.773h9.483v14.394h-9.483V57.773z" fill="#fff" />
				</mask>
				<g mask="url(#a)">
					<path
						fill="#505A63"
						fillRule="evenodd"
						clipRule="evenodd"
						d="M77.709 57.797h-5.552c-.72 0-1.265.702-1.31 1.554L70.24 70.52c-.046.85.59 1.554 1.31 1.554h6.677c.72 0 1.336-1.076 1.297-1.93l-.507-10.792c-.038-.853-.588-1.554-1.31-1.554z"
					/>
				</g>
				<path
					fill="#282626"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M45.445 79.685v-8.513h8.67v8.513h-8.67z"
				/>
				<path
					fill="#373D4A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M47.055 67.805h8.668v4.663h-8.668v-4.663z"
				/>
				<path
					fill="#3E454A"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M68.654 71.172c-.088 2.758-2.099 3.598-4.242 3.598h-28.4c-2.145 0-4.155-.837-4.242-3.598h36.884zM29.898 70.367c0 1.617-.4 1.8-2.2 1.8h-5.397c-.541 0-1.8 0-1.68-1.8h9.277zM79.559 70.367c0 1.617-.401 1.8-2.2 1.8H71.96c-.541 0-1.8 0-1.68-1.8h9.278z"
				/>
				<path
					fill="#999"
					d="M66.85 47.31c.319-.407 1.489-2.208 1.86-2.832.37-.623.834-1.381 1.189-2.108.383-.784 1.056-2.095 1.54-3.048.412-.814 2.424-4.432.095-7.174-1.186-1.025-1.088-2.147-3.625-2.719-3.62-.817-5.476.955-8.957-.407-1.642-.644-2.465-1.559-3.262-2.927-.276-.476.037-2.615 0-3.064-.033-.403-.432-.72-.926-.72l-9.634-.014c-.502 0-.923.324-.935.734-.018.607.286 2.55 0 3.064-.427 1.136-1.82 2.258-3.819 2.927-1.988.748-3.386.407-6.906.407-1.3 0-2.718 1.13-3.625 1.813-.692.521-1.615 2.932-1.813 3.625-.198.693.557 2.215 1.195 3.882.638 1.667 1.525 3.081 1.666 3.488.142.407.993 2.243 1.277 2.766.283.524 1.077 1.894 1.205 2.058.128.164.745 1.104.993 1.511.142.261.581 1.08.709 1.337.26.524 2.31 3.983 2.487 5.262.255 1.84.462 5.605.462 7.804-.297 3.495-.289 8.9-1.838 16.3-.174.834-.127 1.834 0 2.996.352 3.212 2.576 7.775 14.914 7.775s14.196-6.758 14.323-7.775c.127-1.017.158-1.747 0-2.996-.157-1.25-1.893-12.375-2.156-16.3-.115-1.707 0-6.056.263-7.804.293-1.944 1.417-4.746 2.441-6.497.203-.347.558-.957.877-1.364z"
				/>
				<path
					fill="#7F7F7F"
					d="M71.906 56.654c.414.329.882.573 1.376.718a3.731 3.731 0 001.504.127 3.552 3.552 0 002.493-1.503c.447-.636.772-1.711.732-2.21a17.967 17.967 0 00-.128-1.185c-.116-.812-.277-1.25-.543-2.031-.54-1.571-.468-1.22-.986-2.575-.434-1.718-.894-3.117-1.449-6.423a42.074 42.074 0 00-1.562-6.329c-.18-.505-.354-.98-.502-1.413l-.013-.053c-.24-.603-.457-1.164-.633-1.591a5.775 5.775 0 00-1.485-1.794 5.921 5.921 0 00-2.021-1.047 5.457 5.457 0 00-2.208-.178c-.731.093-1.442.252-2.056.719a4.233 4.233 0 00-1.093 1.379c-.21.417-.965 1.484-.954 4.016a7.7 7.7 0 00.193 1.54c.04.173-.04-.158 0 0 .433 1.826 1.049 3.445 1.832 5.096.79 1.666 1.579 2.838 1.579 2.838.736 1.235.912 1.42 1.514 2.548.55 1.027 1.144 2.325 1.649 3.448.397 1.15 1.077 2.754 1.24 3.213.269.756.38 1.227.64 1.69.262.461.474.67.881 1zM45.157 5.134C46.063 4.586 48.203 4 49.513 4s3.294.102 4.916 1.134c1.62 1.032 2.214 1.796 2.585 2.427.371.63 1.19 2.5 1.503 4.054.342 1.701.211 3.029.143 3.603-.174 1.47-.947 3.98-1.606 5.188-.659 1.208-2.625 4.884-3.59 6.06C52.5 27.644 51.703 28 49.681 28c-1.79 0-2.944-1.071-3.734-1.954-.79-.882-3.012-4.747-3.31-5.251-.299-.504-1.562-3.046-1.761-4.737-.2-1.691-.156-3.402 0-4.443.155-1.041.809-2.825 1.586-4.054.778-1.23 1.79-1.878 2.695-2.427zM27.989 56.982c-.415.329-.882.573-1.376.718a3.731 3.731 0 01-1.505.127 3.549 3.549 0 01-2.493-1.503c-.447-.635-.771-1.711-.732-2.21.026-.325.067-.773.128-1.184.116-.813.277-1.25.544-2.032.54-1.571.467-1.22.985-2.575.435-1.718.895-3.117 1.45-6.423a42.057 42.057 0 011.561-6.329c.18-.505.354-.98.503-1.413l.012-.053c.241-.603.457-1.163.634-1.591a5.774 5.774 0 011.484-1.793 5.923 5.923 0 012.021-1.048 5.46 5.46 0 012.208-.178c.732.093 1.443.252 2.056.72.611.502.932 1.059 1.093 1.378.21.417.966 1.485.955 4.016a7.706 7.706 0 01-.193 1.541c-.041.172.039-.159 0 0-.433 1.825-1.049 3.444-1.832 5.095a24.053 24.053 0 01-1.58 2.838c-.736 1.235-.912 1.421-1.514 2.548-.549 1.027-1.143 2.325-1.648 3.448-.397 1.15-1.078 2.754-1.24 3.213-.27.756-.38 1.227-.641 1.69-.261.461-.474.67-.88 1z"
				/>
				<mask
					id="b"
					x={4}
					y={57}
					width={94}
					height={16}
					maskUnits="userSpaceOnUse"
					style={{ maskType: 'luminance' }}
				>
					<path d="M4 57h93.56v15.233H4V57z" fill="#fff" />
				</mask>
				<g mask="url(#b)">
					<path d="M97.472 69.655v2.578H4.012v-2.578L8.542 57h84.4l4.53 12.655z" fill="#BEC4CB" />
				</g>
				<path d="M4.012 69.656h93.46v2.578H4.012v-2.578z" fill="#6E7B88" />
				<path
					fill="#999"
					d="M27.022 61.652c-.368.11-.717.15-1.2.143-.482-.006-.952.014-1.192.013-.399-.001-2.479.061-2.73-.113-.314-.218-.267-.819-.333-1.284-.196-1.388-.2-2.34-.203-3.123-.001-.6-.005-1.56.183-2.254.19-.693.748-1.005 1.07-1.192.323-.188.863-.396 1.657-.423 1.027.01 1.419.052 2.254.28.718.197.995.478 1.232.636.285.19.681.754.749.998.183.774.08.922-.198 1.7-.242.616-.241.937-.469 1.561-.206.696-.276 1.166-.29 1.525-.011.298.045.901.005 1.107-.04.205-.186.321-.535.426z"
				/>
				<path
					fill="#999"
					d="M25.203 67.226c1.093 0 1.782-.09 2.642-.741.604-.458.73-1.54.998-2.216.105-.266.739-.087 1.164-.567.376-.424.77-1.06.38-1.549-.47-.59-.873-.284-1.41-.35-.292-.566-.405-1.077-1.099-1.374-.643-.275-1.109-.124-1.814-.043-.554.063-1.382.283-2.44.589-.941.271-1.407.358-2.284.785-.582.283-1.155.726-1.253 1.265-.079.43.041.694.224 1.091.397.862.638 2.069 1.689 2.543 1.258.567 2.364.567 3.177.567h.026zM72.873 61.32c.367.11.716.15 1.199.143.483-.006.953.014 1.192.013.4-.001 2.48.061 2.73-.113.315-.218.268-.819.334-1.284.196-1.388.2-2.34.202-3.123.002-.6.006-1.56-.183-2.254-.189-.693-.747-1.005-1.07-1.192-.322-.188-.863-.396-1.656-.423-1.028.01-1.42.051-2.254.28-.719.197-.995.478-1.233.636-.285.19-.68.754-.748.997-.183.775-.08.923.197 1.7.243.617.242.938.47 1.563.206.695.276 1.165.29 1.524.01.298-.045.901-.005 1.107.04.205.186.321.535.426z"
				/>
				<path
					fill="#999"
					d="M74.696 66.894c-1.093 0-1.783-.09-2.642-.741-.605-.458-.73-1.54-.999-2.216-.105-.266-.738-.087-1.164-.567-.375-.424-.77-1.06-.38-1.55.47-.588.874-.283 1.411-.348.292-.567.404-1.078 1.098-1.375.644-.275 1.11-.124 1.814-.043.554.063 1.382.283 2.44.589.942.271 1.408.358 2.284.785.583.283 1.156.726 1.254 1.265.078.43-.042.694-.224 1.091-.397.862-.638 2.069-1.69 2.543-1.257.567-2.363.567-3.176.567h-.026z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_16454">
					<path fill="#fff" d="M0 0H102V72H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
